import React, { Component } from 'react';
import cx from 'classnames';
import TouchPointBenefits from './touch-point-benefits';
import Slider from 'react-slick';

class CarouselTouchPoint extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSlide: 0,
    };
  }

  render() {
    const {
      itemsTouchPoints,
    } = this.props;

    const settings = {
      arrows: false,
      autoplay: true,
      autoplaySpeed: 6000,
      beforeChange: (_, next) => this.setState({ currentSlide: next }),
      centerMode: true,
      dots: false,
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      speed: 900,
      swipe: true,
      variableWidth: true,
    };

    return (
      <div className='CarouselTouchPoint' >
        <div className='CarouselTouchPoint-content-items'>
          <Slider
            ref={ c => { this.slider = c; } }
            {...settings} >
            {
              this.renderItem(itemsTouchPoints)
            }
          </Slider>
        </div>
        { this.renderDots(itemsTouchPoints) }
      </div>
    );
  }

  renderItem = (items) => {
    const {
      titleColor,
    } = this.props;

    return items.map((item, index ) => (
      <TouchPointBenefits
        item={ item }
        key={ index }
        titleColor={ titleColor }
      />
    ));
  }

  renderDots = (items) => {
    const {
      currentSlide,
    } = this.state;

    return (
      <ul className='CarouselTouchPoint-options'>
        { items.map((_, index) => {
          const dotClass = cx({ 'CarouselTouchPoint-options--active': index === currentSlide });

          return (
            <li
              className={ dotClass }
              onClick={ () => this.handleClick(index) }
              key={ index }
            />
          );
        })
        }
      </ul>
    );
  }

  handleClick = (to) => {
    this.slider.slickGoTo(to);
  }
}

export default CarouselTouchPoint;